/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
export { default as wrapRootElement } from "./src/store/reduxWrapper"

export const onServiceWorkerUpdateReady = () => window.location.reload()
